import { filterChartDatasets } from './filterChartDatasets';

export const applyChartDatasetsFilter = ({
	rawData,
	selectedProducts,
	setChartData,
}) => {
	if (!rawData) {
		return;
	}

	setChartData(() => filterChartDatasets(rawData, selectedProducts));
};
